module.exports = __webpack_public_path__ + "img/cns_pc11.21500157.png";